import { Outlet, useLocation, useNavigate } from 'react-router-dom';

import { t } from '@/i18n';
import { useAuth } from '@/router/AuthContext';
import { matchesAnyPathname } from '@/shared/lib/utils/pathname';
import { Button } from '@/shared';
import { SlideTab } from '@/shared/ui/SlideTab';

const TAB_PATHS = ['/board/idea', '/board/feed'];
const WRITE_PATHS = ['/board/idea/write', '/board/feed/write'];

export const BoardLayout = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  // TRAD-2102 — 이 탭은 여태 운영에서 렌더되지 않아 한글 하드코딩이 드러나지 않았다.
  // 노출을 되살리면서 i18n 카탈로그 경유로 교정한다(AppSidebar 와 동일하게 렌더마다 재조립 —
  // 모듈 스코프 상수로 두면 최초 평가 시점 로케일에 고정됨. TRAD-2057 패턴).
  const tabs = [t('board.tab.idea'), t('board.tab.feed')];

  const activeIndex = pathname.startsWith('/board/feed') ? 1 : 0;
  // TRAD-2102 — 운영 인프라가 끝 슬래시(`/board/idea/`)로 리다이렉트하므로 `===` 정확 비교로는
  // 운영에서만 false 가 되어 탭·글쓰기 FAB 가 사라진다. 정규화 헬퍼 경유 필수.
  const isListPage = matchesAnyPathname(pathname, TAB_PATHS);

  const handleTabChange = (index: number) => {
    navigate(TAB_PATHS[index]);
  };

  const handleWrite = () => {
    navigate(WRITE_PATHS[activeIndex]);
  };

  return (
    <div className="relative max-w-screen-xl mx-auto w-full px-4">
      {/* 검색바는 각 목록 페이지가 소유한다(TRAD-2102 중복 제거) —
          탭 전환 시 페이지가 remount 되며 keyword 입력 상태가 URL 과 함께 리셋되어야 하기 때문. */}
      {isListPage && (
        <div className="sticky top-0 bg-background z-10 pt-4 pb-3">
          <SlideTab tabs={tabs} activeIndex={activeIndex} onChange={handleTabChange} />
        </div>
      )}
      <Outlet />
      {isListPage && isAuthenticated && (
        <div className="sticky bottom-6 mt-[-3rem] flex justify-end pointer-events-none z-20 pr-4">
          <Button
            onClick={handleWrite}
            className="h-14 w-14 rounded-full p-0 shadow-lg pointer-events-auto hover:scale-105 transition-all"
          >
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 5v14M5 12h14" />
            </svg>
          </Button>
        </div>
      )}
    </div>
  );
};
